var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailCover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4 17.5999C15.989 17.8813 15.4977 18.0217 15 17.9999C14.5023 18.0217 14.011 17.8813 13.6 17.5999L3 11.8999V21.9999C3 22.7956 3.31607 23.5586 3.87868 24.1212C4.44129 24.6838 5.20435 24.9999 6 24.9999H24C24.7956 24.9999 25.5587 24.6838 26.1213 24.1212C26.6839 23.5586 27 22.7956 27 21.9999V11.8999L16.4 17.5999Z",
    fill: "#7F8FA4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 5H6.00001C5.20437 5 4.4413 5.31607 3.87869 5.87868C3.31609 6.44129 3.00001 7.20435 3.00001 8V9C2.99906 9.18032 3.04456 9.35785 3.13213 9.51549C3.21971 9.67312 3.3464 9.80555 3.50001 9.9L14.5 15.9C14.6536 15.9808 14.8272 16.0156 15 16C15.1728 16.0156 15.3465 15.9808 15.5 15.9L26.5 9.9C26.6536 9.80555 26.7803 9.67312 26.8679 9.51549C26.9555 9.35785 27.001 9.18032 27 9V8C27 7.20435 26.6839 6.44129 26.1213 5.87868C25.5587 5.31607 24.7957 5 24 5Z",
    fill: "#7F8FA4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailCover);
export default __webpack_public_path__ + "static/media/mail-cover.e6574f56.svg";
export { ForwardRef as ReactComponent };